import { ANIM_ROWS, type AnimName, AVATAR_IDS, SHEET_COLUMNS } from "@agency/shared";
import type Phaser from "phaser";

export function animKey(avatarId: string, anim: AnimName): string {
  return `${avatarId}:${anim}`;
}

/** Register idle/walk/sit/drink animations for every avatar sheet. */
export function registerAnimations(scene: Phaser.Scene): void {
  for (const avatar of AVATAR_IDS) {
    for (const [anim, row] of Object.entries(ANIM_ROWS) as Array<[AnimName, number]>) {
      const key = animKey(avatar, anim);
      if (scene.anims.exists(key)) continue;
      const start = row * SHEET_COLUMNS;
      scene.anims.create({
        key,
        frames: scene.anims.generateFrameNumbers(avatar, {
          start,
          end: start + SHEET_COLUMNS - 1,
        }),
        frameRate: anim.startsWith("walk") ? 8 : 4,
        repeat: -1,
      });
    }
  }
}
